import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { ImageGallery } from 'containers/misc'
import { TableSecondary, TableRow, TableData } from 'components/layout/Table'
import { Title } from 'components/layout'
import { assessorActivities as assessorLayout } from 'constants/layout/assessor'
import styles from './assessor-participant-logs.styl'

export default class AssessorParticipantLogs extends Component {
  static propTypes = {
    logs: PropTypes.array
  }
  static defaultProps = {
    logs: []
  }

  getDurationHHMM = seconds => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor(seconds / 60) - hours * 60

    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`
  }

  render() {
    const { logs } = this.props

    return (
      <div className="base-margin--top">
        <Title h2 className="omega" intlKey="moduleTitle.participant_logs">
          Participant's logs
        </Title>
        <TableSecondary ths={assessorLayout.logsHeaders} transposable>
          {logs.map(item => {
            return (
              <TableRow key={item.id}>
                <TableData>
                  {get(item, 'date') && (
                    <FormattedDate value={get(item, 'date')} />
                  )}
                </TableData>
                <TableData>
                  {this.getDurationHHMM(get(item, 'duration'))}
                </TableData>
                <TableData>
                  <p className={styles.heading}>{get(item, 'name')}</p>
                  <p className={styles.description}>{get(item, 'description')}</p>
                  {item.fileUrls &&
                    item.fileUrls.length > 0 && (
                      <ImageGallery urls={item.fileUrls} small decoWithCode />
                    )}
                </TableData>
              </TableRow>
            )
          })}
        </TableSecondary>
      </div>
    )
  }
}
